import React, { useEffect, createElement } from 'react';
import { Play, CheckCircle, Clock, TrendingUp } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
export function RetargetingPage() {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // Initialize both pixels
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/ffr68lte98.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-4637" data-mp="1dx6i0dgn1tj5">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-4638" data-mp="18y3bspox9h9l">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-4639" data-mp="14yl1soyn2qlj" />
      </noscript>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 py-6 md:py-14" data-id="element-4640" data-mp="qbvvo49vtf66">
        {/* Header Section */}
        <div className="text-center mb-6 md:mb-10 space-y-4" data-id="element-4641" data-mp="udhc1zlmkbl4">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-green-600/20 border border-green-500/50 rounded-full px-4 py-2 mb-4" data-id="element-4642" data-mp="ub4lwz5pquwz">
            <TrendingUp className="w-4 h-4 text-green-400" data-id="element-4643" data-mp="lc9e5in0tcrk" />
            <span className="text-sm font-semibold text-green-400" data-id="element-4644" data-mp="levn9mpk80bw">
              Estudio de Caso Real
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-black leading-tight max-w-4xl mx-auto tracking-tight" data-id="element-4645" data-mp="1e05bmpkez8pe">
            Cómo Generé{' '}
            <span className="text-green-500" data-id="element-4646" data-mp="14bnc0bnvf7nc">$200,000 Desde Cero</span> en 30
            Días – Estudio de Caso en Vivo
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-gray-100 max-w-3xl mx-auto leading-relaxed" data-id="element-4647" data-mp="1rzn013tssjy8">
            Accede a un video exclusivo donde te muestro paso a paso cómo
            apliqué la estrategia exacta que hoy enseñamos en el curso.
          </p>
        </div>

        {/* Video Section */}
        <div className="mb-12 md:mb-16" data-id="element-4648" data-mp="3ciqt269jtfma">
          <div className="relative" data-id="element-4649" data-mp="3qaf7ig79sg6f">
            {/* Neon green gradient shadow */}
            <div className="absolute -inset-2 bg-gradient-to-r from-green-500 via-green-400 to-green-500 opacity-75 blur-2xl" data-id="element-4650" data-mp="3qchuerd4lt6x"></div>

            <div className="relative aspect-video bg-gray-900 border border-green-500/50 overflow-hidden shadow-2xl" data-id="element-4651" data-mp="2yipjm2f7wzv7">
              {/* Wistia Video Player */}
              <wistia-player media-id="ffr68lte98" aspect="1.7777777777777777" className="w-full h-full" data-id="element-4652" data-mp="2tmqzws4u4614"></wistia-player>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="max-w-3xl mx-auto mb-10 md:mb-14" data-id="element-4653" data-mp="32nfebny548ej">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-5 md:p-7 space-y-5" data-id="element-4654" data-mp="msn7ceizcpx5">
            <h2 className="text-lg md:text-xl font-bold text-center mb-5" data-id="element-4655" data-mp="hu27whbjya9r">
              En Este Video Descubrirás:
            </h2>

            <div className="space-y-4" data-id="element-4656" data-mp="1d7ehg89dhkb2">
              <div className="flex items-start gap-4" data-id="element-4657" data-mp="1i3bn9kn0f89l">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-600/20 border border-green-500/50 flex items-center justify-center mt-1" data-id="element-4658" data-mp="1i5y5ce7j1662">
                  <CheckCircle className="w-4 h-4 text-green-400" data-id="element-4659" data-mp="1s3c8jc4fvygf" />
                </div>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-4660" data-mp="1w4o37w2679vh">
                  Ve la estrategia exacta que utilicé para escalar de cero a
                  $200,000 en solo 30 días.
                </p>
              </div>

              <div className="flex items-start gap-4" data-id="element-4661" data-mp="25uhawlz6z4ug">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-600/20 border border-green-500/50 flex items-center justify-center mt-1" data-id="element-4662" data-mp="2at2441g10o9e">
                  <CheckCircle className="w-4 h-4 text-green-400" data-id="element-4663" data-mp="2fpsjsnnx5hua" />
                </div>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-4664" data-mp="2jtqgkrprugk6">
                  Descubre los errores que evitamos y cómo los corregimos en
                  tiempo real.
                </p>
              </div>

              <div className="flex items-start gap-4" data-id="element-4665" data-mp="3vatb6tyjyk4z">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-600/20 border border-green-500/50 flex items-center justify-center mt-1" data-id="element-4666" data-mp="3vbcvghbodkm6">
                  <CheckCircle className="w-4 h-4 text-green-400" data-id="element-4667" data-mp="rtupygjdkpox" />
                </div>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-4668" data-mp="mv19cf8skikj">
                  Aprovecha este estudio de caso práctico que ya ha ayudado a
                  cientos de alumnos a aplicar el método.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="max-w-2xl mx-auto text-center space-y-5" data-id="element-4669" data-mp="1alnjqd69qexp">
          <a href="https://www.fanbasis.com/agency-checkout/true-marketer/Yv2lp" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-b from-[#06b6d4] to-[#0891b2] hover:from-[#0891b2] hover:to-[#0e7490] text-white font-bold text-lg md:text-xl rounded-xl py-5 px-8 shadow-lg hover:shadow-[#06b6d4]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-4670" data-mp="15tvnpn4cfh06">
            Accede Hoy Por Solo $297
          </a>

          {/* Payment Options */}
          <p className="text-gray-200 text-sm md:text-base" data-id="element-4671" data-mp="2v8woi7hakape">O 4 pagos de $75</p>

          {/* Urgency */}
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4" data-id="element-4672" data-mp="2gg388ju73qjo">
            <div className="flex items-center justify-center gap-2 text-yellow-400" data-id="element-4673" data-mp="2laqmzqzed6l2">
              <Clock className="w-5 h-5" data-id="element-4674" data-mp="27en06iqus0im" />
              <p className="text-sm md:text-base font-semibold" data-id="element-4675" data-mp="2cbvgedsfxuh8">
                Este video estará disponible solo por tiempo limitado. ¡Accede
                antes de que lo retiremos!
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-6 md:py-10 mt-14" data-id="element-4676" data-mp="aifprgwcsfm9">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-4677" data-mp="kmmdag1bfdh7">
          <div className="mb-5" data-id="element-4678" data-mp="fqoxqbxvmb5h">
            <p className="text-[#06b6d4] font-bold text-lg md:text-xl mb-2" data-id="element-4679" data-mp="frgq7dw6fsrj">
              48HRSCASHMACHINE.COM
            </p>
          </div>

          <div className="text-gray-300 text-xs md:text-sm leading-relaxed space-y-3" data-id="element-4680" data-mp="opshli4vaul1">
            <p data-id="element-4681" data-mp="13eycitwo9yn4">
              Derechos de autor © 2025, 48 Hrs AI Cash Machine: Todos los
              derechos reservados.
            </p>
            <p className="text-gray-200" data-id="element-4682" data-mp="yfc1mr4bguhh">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#06b6d4] hover:text-[#0891b2] transition-colors" data-id="element-4683" data-mp="1cgeo34z846sx">
                support@truemarketer.com
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>;
}